module.exports = __webpack_public_path__ + "media/images/general/exclamation-9a770730f18559073ff00ab7913cabad.svg";